import { Icons } from '@commenda/kakashi';

export const PricingCardFeaturesList = ({
  productFeatures,
}: {
  productFeatures: string[];
}) => {
  return (
    <ul className="space-y-3">
      {productFeatures?.map((feature) => (
        <li key={feature} className="flex items-start gap-2">
          <Icons.Check className="size-5 text-fg-success-hover shrink-0 mt-0.5" />
          <span className="txt-small-medium text-text-primary">{feature}</span>
        </li>
      ))}
    </ul>
  );
};
